var React = require('react');

var PlayerTable = React.createClass({
    render : function(){
        
        var rows = [];
        var stats = this.props.stats || [];
        var statList = this.props.statList || {};
        var headings = [<th key="logo"><img src={this.props.team.logo} className="imageLoaded"/> {this.props.team.abbreviation}</th>];
        
        for (var stat in statList){
            headings.push(<th key={stat}><span style={{fontFamily:'inherit',fontWeight:'inherit'}} className="tooltip icon-font icon-soccer-goal-solid" data-tooltip={statList[stat].text}>{statList[stat].label}</span></th>);
        }
        
        stats.map(function(stat, i){
            stat = stat || {stats : []};
            var lastRow = (i == stats.length-1);
            var noBottomBorder = {borderBottom : 'none'};
            var nameParts = (stat.name || '').split(' ');
            var firstChar = (stat.name || '')[0];
            var lastName = nameParts[nameParts.length-1] || '';
            var playerStats = [<td style={ lastRow ? noBottomBorder : null} key={stat.id}><a target="_blank" href={stat.href}>{firstChar + ' ' + lastName}</a><span style={{fontFamily:'inherit', paddingLeft:'3px'}} className="tooltip icon-font icon-soccer-goal-solid" data-tooltip={stat.positionName}>{stat.position}</span></td>];
            
            stat.stats.map(function(s, j){
                var props = {
                    key : j
                };
                if(lastRow){
                    props.style = noBottomBorder;
                }
                playerStats.push(
                    <td {...props}>{s.displayValue}</td>
                );
            });
            
            if(!stat.stats.length){
                playerStats.push(
                    <td key={i} colSpan={headings.length-1}></td>
                );
            }
            
            rows.push(
                <tr key={'r.' + stat.id}>
                    {playerStats}
                </tr>
            );
        });
        
        return (
            <table className="mod-data">
                <thead>
                    <tr className="header">
                        {headings}
                    </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        );
    }
});

var Tables = React.createClass({
    render: function(){
        return (
            <div>
                <div className={"table-wrap" + (this.props.selectedTeam === 'home' ? ' active' : '')}>
                    <PlayerTable selectedTeam={this.props.selectedTeam === 'home' ? true : false} team={this.props.home} statList={this.props.statList} stats={this.props.homeStats} />
                </div>
                <div className={"table-wrap" + (this.props.selectedTeam === 'away' ? ' active' : '')}>
                    <PlayerTable selectedTeam={this.props.selectedTeam === 'away' ? true : false} team={this.props.away} statList={this.props.statList} stats={this.props.awayStats} />
                </div>
            </div>
        );
    }
});

var PlayerStatsTable = React.createClass({
    clickHandler : function(selected, event){
        this.setState({
            selected : selected
        });
    },
    switchTeam: function(team, event){
        this.setState({
            selectedTeam : team
        });
    },
    getInitialState: function(){
        return {
            selected : 'Scoring',
            selectedTeam : 'home'
        };
    },
    filters : {
        Scoring : {
            tries: {
                label : 'T',
                text : 'Tries',
                index : 0
            },
            tryAssist: {
                label : 'A',
                text : 'Try Assists',
                index : 1
            },
            points: {
                label : 'Pts',
                text : 'Points Scored',
                index : 2
            }
        },
        Attacking : {
            kicks: {
                label : 'K',
                text : 'Kicks',
                index : 0
            },
            passes: {
                label : 'P',
                text : 'Passes',
                index : 1
            },
            runs: {
                label : 'R',
                text : 'Runs',
                index : 2
            },
            metres: {
                label : 'MR',
                text : 'Metres Run with ball',
                index : 3
            },
            cleanBreaks: {
                label : 'CB',
                text : 'Clean Breaks',
                index : 4
            },
            defendersBeaten: {
                label : 'DB',
                text : 'Defenders Beaten',
                index : 5
            },
            offload: {
                label : 'OL',
                text : 'Offloads',
                index : 6
            },
            lineoutWonSteal: {
                label : 'LS',
                text : 'Lineouts Stolen',
                index : 7
            }
        },
        Defending : {
            turnoversConceded: {
                label : 'TC',
                text : 'Turnovers Conceded',
                index : 0
            },
            tackles: {
                label : 'Tack',
                text : 'Tackles',
                index : 1
            },
            missedTackles: {
                label : 'MT',
                text : 'Missed Tackles',
                index : 2
            },
            lineoutsWon: {
                label : 'LO',
                text : 'Lineouts won on throw',
                index : 3
            }
        },
        Discipline : {
            penaltiesConceded: {
                label : 'Pen',
                text : 'Penalties conceded',
                index : 0
            },
            yellowCards: {
                label : 'Y',
                text : 'Yellow Cards',
                index: 1
            },
            redCards: {
                label : 'R',
                text : 'Red Cards',
                index: 2
            }
        }
    },
    render : function(){
        
        var tabs = ['Scoring', 'Attacking', 'Defending', 'Discipline'];
        var selected = this.state.selected;
        var tabsList = [];
        var store = this.props.store;
        var homeStats = store.getPlayerStats(this.filters[selected], true);
        var awayStats = store.getPlayerStats(this.filters[selected], false);

        tabs.map(function(tab, i){
            var props = {
                style : {padding: '0 7px'}
            };
            if(selected === tab){
                props.className = "active";
            }
            tabsList.push(<li onClick={this.clickHandler.bind(this, tab)} key={tab} {...props}><span>{tab}</span></li>);
        }.bind(this));
        
        return (
            <div className="sub-module tabbedTable" style={{'overflowX':'auto'}}>
            	<header className="hidden-sm hidden-md hidden-lg">
                    <div className="filter form-group button-group">
                        <button onClick={this.switchTeam.bind(this,'home')} className={"button-filter-alt lg fixed" + (this.state.selectedTeam === 'home' ? ' active' : '')}><span className="team-name">{this.props.home.abbreviation}</span></button>
                        <button onClick={this.switchTeam.bind(this,'away')} className={"button-filter-alt lg fixed" + (this.state.selectedTeam === 'away' ? ' active' : '')}><span className="team-name">{this.props.away.abbreviation}</span></button>
                    </div>
            	</header>

                <div className="tab-container alt">
                    <ul className="tabs alt" data-behavior="tabs_transform">
                        {tabsList}
                    </ul>
                </div>
                
            	<div className="tab-content">
            		<div className={"tab-pane" + this.state.selected == 'Scoring' ? " active" : ""}>
        				<Tables selectedTeam={this.state.selectedTeam} home={this.props.home} away={this.props.away} statList={this.filters[selected]} homeStats={homeStats} awayStats={awayStats} selected={this.state.selected} />
            		</div> 
            	</div>
            </div>
        );
    }
});

module.exports = PlayerStatsTable;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/PlayerStatsTable.jsx
 **/